import type { PropsWithChildren } from "react";
import { MorphemeMnemonicsPanelContext } from "#morpheme-mnemonics-panel-context";
import { useMorphemeMnemonicsPanelContextValue } from "#morpheme-mnemonics-panel-context-value";

export function MorphemeMnemonicsPanelContextProvider({
  children,
  ...props
}: PropsWithChildren<Parameters<typeof useMorphemeMnemonicsPanelContextValue>[0]>) {
  const value = useMorphemeMnemonicsPanelContextValue(props);
  return (
    <MorphemeMnemonicsPanelContext.Provider value={value}>
      {children}
    </MorphemeMnemonicsPanelContext.Provider>
  );
}
